import React from "react";
import EditActivities from "./EditActivities";
import AddActivity from "./AddActivity";

class ActivitiesContainer extends React.Component {
  render() {
    return (
      <div className="activities-container">
        <EditActivities
          stopwatchindex={this.props.stopwatchindex}
          stopwatch={this.props.stopwatch}
          updateStopwatch={this.props.updateStopwatch}
          updateActivity={this.props.updateActivity}
          deleteActivity={this.props.deleteActivity}
        />

        <div
          className="blurb"
          dangerouslySetInnerHTML={{
            __html: window["_stopwatchContextInfo"].inStopwatchBlurb
          }}
        ></div>

        <AddActivity
          stopwatchindex={this.props.stopwatchindex}
          stopwatch={this.props.stopwatch}
          updateStopwatch={this.props.updateStopwatch}
          addActivity={this.props.addActivity}
        />
      </div>
    );
  }
}

export default ActivitiesContainer;
